__turbopack_context__.v({
  "controlBar": "index-module__v5ZqaW__controlBar",
  "leftgap": "index-module__v5ZqaW__leftgap",
  "playButton": "index-module__v5ZqaW__playButton",
  "timeRange": "index-module__v5ZqaW__timeRange",
  "toolbar": "index-module__v5ZqaW__toolbar",
  "wrapper": "index-module__v5ZqaW__wrapper",
});
